import { getTrackingPageBlockDefinition, getTrackingPageBlockDefinitions } from '@reveni-io/reveni-ui'

import { editorBlockMetadata, maxRecommendedProducts, previewRecommendedProductPrice } from './constants'

export const getPreviewRecommendedProducts = t => {
  return Array.from({ length: maxRecommendedProducts }, (_, index) => ({
    id: `preview-product-${index + 1}`,
    name: `${t('Producto')} ${index + 1}`,
    from_price: (previewRecommendedProductPrice.base + index * previewRecommendedProductPrice.step).toFixed(2),
  }))
}

export const getBlockDefinitions = ({ fallbackRecommendedProducts, getRecommendedProductsService } = {}) => {
  return getTrackingPageBlockDefinitions({ fallbackRecommendedProducts, getRecommendedProductsService })
    .filter(definition => Boolean(editorBlockMetadata[definition.id]))
    .map(definition => ({ ...definition, ...editorBlockMetadata[definition.id] }))
}

export const getBlockDefinition = blockId => {
  return getTrackingPageBlockDefinition(getBlockDefinitions(), blockId)
}

export const isBlockConfigurable = definition => Boolean(definition.settingsSections)

export const getBlockSettingFields = definition => {
  if (!definition.settingsSections) return []

  return definition.settingsSections.flatMap(section => section.fields)
}

export const getBlockDefaultSettings = definition => {
  const entries = getBlockSettingFields(definition).map(field => [field.key, field.defaultValue])

  return Object.fromEntries(entries)
}

export const getBlockSettings = (definition, savedSettings) => {
  return { ...getBlockDefaultSettings(definition), ...savedSettings }
}

export const getValidBlockNumber = (value, { min, max, defaultValue }) => {
  const number = Number(value)

  if (value === '' || value === null || Number.isNaN(number)) return defaultValue
  if (number < min) return min
  if (number > max) return max

  return number
}
